import React, { useEffect, useState } from "react";
import { useSearchParams, useLocation } from "react-router-dom";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { getData, Postdata, postDataWithToken } from "../../API/GlobalApi";
import Notifier from "../../Utils/notify";

const StudentFeePaymentTemplates = () => {
    // Force reload on first visit to ensure validation runs
    useEffect(() => {
        const hasReloaded = sessionStorage.getItem('payment_page_reloaded');
        if (!hasReloaded) {
            sessionStorage.setItem('payment_page_reloaded', 'true');
            window.location.reload();
        }
    }, []);
    const allParams = window.location.search;
    const signatureCount = (allParams.match(/signature=/g) || []).length;
    const userIdCount = (allParams.match(/user_id=/g) || []).length;
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const userId = searchParams.get("user_id");
    const uniqueId = searchParams.get("unique_id");
    const specialization_id = searchParams.get("specialization_id")
    const provisional_admission = searchParams.get('provisional_admission')
    const course_name = searchParams.get('course_name')
    const student_name = searchParams.get('student_name')
    const [studentData, setStudentData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [amount, setAmount] = useState("");
    const [isValidLink, setIsValidLink] = useState(signatureCount <= 1 && userIdCount <= 1);
    // Redirect on mount and location change if invalid
    useEffect(() => {
        const params = window.location.search;
        const sigCount = (params.match(/signature=/g) || []).length;
        const uidCount = (params.match(/user_id=/g) || []).length;

        if (sigCount > 1 || uidCount > 1) {
            setIsValidLink(false);
            window.location.replace('/invalid-payment-link');
            return;
        }
        setIsValidLink(true);
    }, [location.search]);
    // Fetch student details
    useEffect(() => {
        if (!isValidLink) return;

        const fetchStudentDetails = async () => {
            try {
                setLoading(true);
                const res = await getData(`students/get-students/${userId}`); 
                setStudentData(res);
            } catch (error) {
                Notifier.error("Error fetching student details:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchStudentDetails();
    }, [ userId, isValidLink]);

    // Don't render anything if link is invalid
    if (!isValidLink) {
        return null;
    }

    const handlePayment = async () => {
        if (!amount || Number(amount) < 200) {
            Notifier.info("Please enter an amount of ₹200 or more.");
            return;
        }
        if (!studentData) {
            return;
        }
        const signature = searchParams.get("signature"); // ✅ get signature from URL
        const payload = {
            student_id: userId,
            amount: Number(amount),
            payment_type: "Provisional Admission Fee",
            specialization_id: specialization_id,
            provisional_admission:provisional_admission
        }
        try {
            const res = await postDataWithToken("students/provisional-admission/payment-gateway/", payload);
            if (res?.payment_url) {
                window.location.href = res.payment_url;
            } else {
                Notifier.error(res?.message || "Something went wrong while processing payment.");
            }
        } catch (error) {
            console.error("Payment API error:", error);
            Notifier.error("Failed to process payment. Please try again later.");
        }
    };



    // const paymentgateway = async () => {
    //         const finalobject = {
    //             student_id: studentId,
    //             amount: CourseFees,
    //             payment_type: "Provisional Admission Fee",
    //             specialization_id: specialization_id
    //         }
    //         const url = "students/provisional-admission/payment-gateway/";
    //         const response = await Postdata(url, finalobject);
    //         if (response && response.payment_url) {
    //             window.location.href = response.payment_url;
    //         } else {
    //             displayToast('Payment URL not received!', 'danger');

    //         }

    //     }



    return (
        <SkeletonTheme baseColor="#e0e0e0" highlightColor="#f5f5f5" duration={1.2}>
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-md-8">
                        <div className="card border-0 shadow-sm rounded-4 p-4">
                            <div className="card-body">
                                {/* Page Heading */}
                                <h3 className="text-center mb-4 fw-bold text-primary">
                                    {loading ? (
                                        <Skeleton height={28} width="60%" style={{ margin: "0 auto" }} />
                                    ) : (
                                        "💳 Student Payment"
                                    )}
                                </h3>

                                {/* Student Info Section */}
                                <div className="bg-light p-3 rounded-3 mb-4">
                                    {/* Name */}
                                    <div className="mb-2 d-flex align-items-center gap-2">
                                        {loading ? (
                                            <Skeleton width="60%" height={18} />
                                        ) : (
                                            <>
                                                <strong style={{ minWidth: "130px" }}>Student Name:</strong>
                                                <span className="text-muted">
                                                    {student_name}
                                                </span>
                                            </>
                                        )}
                                    </div>

                                    {/* Registration */}
                                    <div className="mb-2 d-flex align-items-center gap-2">
                                        {loading ? (
                                            <Skeleton width="70%" height={18} />
                                        ) : (
                                            <>
                                                <strong style={{ minWidth: "130px" }}>Registration No:</strong>
                                                <span className="text-muted">
                                                    {studentData?.permanent_registration_number || "N/A"}
                                                </span>
                                            </>
                                        )}
                                    </div>

                                    {/* Course */}
                                    <div className="d-flex align-items-center gap-2">
                                        {loading ? (
                                            <Skeleton width="50%" height={18} />
                                        ) : (
                                            <>
                                                <strong style={{ minWidth: "130px" }}>Course:</strong>
                                                <span className="text-muted">
                                                   {course_name}
                                                </span>

                                            </>
                                        )}
                                    </div>
                                </div>

                                {/* Amount Input */}
                                <div className="mb-4">
                                    {loading ? (
                                        <Skeleton height={50} borderRadius={8} />
                                    ) : (
                                        <>
                                            <label htmlFor="amount" className="form-labell ">
                                                Enter Payment Amount (₹)
                                            </label>
                                            <input
                                                type="number"
                                                id="amount"
                                                className="form-control form-control-lg text-center"
                                                placeholder="Enter amount"
                                                value={amount}
                                                onChange={(e) => {
                                                    const val = e.target.value;

                                                    // Allow only digits
                                                    if (/^\d*$/.test(val)) {
                                                        setAmount(val);
                                                    }
                                                }}
                                                style={{ fontSize: '14px' }}
                                                min={200}
                                            />

                                            {/* {amount && Number(amount) < 200 && (
                                                <small className="text-danger">Minimum amount is ₹200</small>
                                            )} */}


                                        </>
                                    )}
                                </div>

                                {/* Payment Button */}
                                <div className="d-flex justify-content-center">
                                    {loading ? (
                                        <Skeleton height={45} width="60%" borderRadius={30} />
                                    ) : (
                                        <button className="add-btn" onClick={handlePayment}
                                            disabled={!amount || Number(amount) < 200}
                                            style={{
                                                opacity: !amount || Number(amount) < 200 ? 0.6 : 1,
                                                cursor: !amount || Number(amount) < 200 ? "not-allowed" : "pointer",
                                            }}>
                                            <i className="bi bi-credit-card me-2"></i> Make Payment
                                        </button>
                                    )}
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SkeletonTheme>
    );
};

export default StudentFeePaymentTemplates;
